class MFRBlogGrid {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      container: ".blog-grid__grid-entries",
      items: '.blog-card',
      filters: '.blog-grid__filters',
      matchesIndicator: '.blog-grid__counter',
      buttonGroup: '.filter-group',
      loadMoreButton: '.blog-grid__load-more',
      searchField: '.search-recipes-field',
      searchItemsButton: '.search-filter'
    }

    this.counters = {
      limit: 8,
      increment: 8
    }

    this.containers = {
      allItems: [],
      filters: {}
    }

    this.state = {
      searchRegex: null,
      filtersArray: []
    }
    this.filterValue = "";
    this.searchValue = "";

    this.init()
  }

  init() {
    this.$grid = this.$element.find(this.selectors.container)
    this.$filters = this.$element.find(this.selectors.filters)
    this.$buttonGroup = this.$element.find(this.selectors.buttonGroup)
    this.$matchesIndicator = this.$element.find(this.selectors.matchesIndicator)
    this.$loadMoreButton = this.$element.find(this.selectors.loadMoreButton)
    this.$searchButton = this.$element.find(this.selectors.searchItemsButton)
    this.$searchField = this.$element.find(this.selectors.searchField)

    this.initBlogGrid()
  }

  initBlogGrid() {
    this.$filters.on('click', 'button', this.__handleFilterEvent.bind(this))
    this.$loadMoreButton.on('click', this.__handleLoadMoreItemsEvent.bind(this))
    this.$searchField
      .on('keyup', this.__handleSearchFieldTypingEvent.bind(this))
      .on("keydown", (e) => {
        if( e.originalEvent.key == "Enter" )
          this.__handleSearchItemsEvent();
      } );
    this.$searchButton.on('click', this.__handleSearchItemsEvent.bind(this))
    this.$buttonGroup.on('click', 'button', this.__handleFilterActiveState.bind(this))

    this.$container = this.$grid.isotope({
      itemSelector: this.selectors.items,
      layoutMode: 'fitRows'
    })

    this.$grid.find(this.selectors.items).slice(this.counters.limit).addClass('hidden')
    this.$container.isotope('layout')
  }

  __handleFilterEvent(e) {
    let filterGroup = $(e.currentTarget).parents(this.selectors.buttonGroup).attr('data-filter-group')
    this.state.filtersArray[filterGroup] = $(e.currentTarget).attr('data-filter')

    this.filterValue = this.helperConcatValues(this.state.filtersArray)

    // if ( this.state.searchRegex != null ) {
    //   filterValue = filterValue + this.state.searchRegex
    // }

    this.__handleReInitializeIsotopeEvent()
  }

  __handleSearchItemsEvent() {
    this.searchValue = new RegExp(this.$searchField.val(), "gi");
    
    this.__handleReInitializeIsotopeEvent()
  }

  __handleSearchFieldTypingEvent(e) {
    let isSearchKeywordValid = $(e.currentTarget).val().trim().length

    if ( isSearchKeywordValid === 0 ) {
      this.filterValue = this.helperConcatValues(this.state.filtersArray)

      this.$searchButton.prop('disabled', true)
      this.__handleReInitializeIsotopeEvent()
      this.state.searchRegex = null
    } else {
      this.$searchButton.prop('disabled', false)
    }
  }

  __handleReInitializeIsotopeEvent() {
    this.$grid.find(this.selectors.items).removeClass('hidden')
    this.$container.isotope({ filter: (i,e) => {
      const searchResult = this.searchValue != "" ? $( e ).text().match( this.searchValue ) : true;
      const classResult = this.filterValue != "" ? $( e ).is( this.filterValue ) : true;
      
      return classResult && searchResult;
    } })
    this.__handleMatchItemsEvent()
    this.__handleGridItemsRelayout()
  }

  __handleGridItemsRelayout() {
    let $items = $(this.containers.allItems)
    $items.length < this.counters.limit ? this.$loadMoreButton.hide() : this.$loadMoreButton.show()
    $items.slice(this.counters.limit).addClass('hidden')
    this.$container.isotope('layout')
  }

  __handleLoadMoreItemsEvent() {
    let $hiddenItems = this.$grid.find('.hidden')

    $hiddenItems.slice(0, this.counters.increment).removeClass('hidden')
    $hiddenItems = this.$grid.find('.hidden')
    this.$container.isotope('layout')
    
    if ( $hiddenItems.length === 0 ) {
      this.$loadMoreButton.hide()
    }
  }

  __handleFilterActiveState(e) {
    $(e.currentTarget).parents(this.selectors.buttonGroup).find('.is-selected').removeClass('is-selected')
    $(e.currentTarget).addClass('is-selected')
  }

  __handleMatchItemsEvent() {
    this.containers.allItems = this.$container.isotope('getFilteredItemElements')

    if ( this.containers.allItems.length === 0 ) {
      this.$matchesIndicator.text('No recipes found.')
    } else {
      this.$matchesIndicator.text(`Found ${this.containers.allItems.length} recipes`)
    }
  }

  helperConcatValues(obj) {
    let value = ''

    for ( let prop in obj ) {
      value += obj[ prop ]
    }

    return value
  }
}